import { render, staticRenderFns } from "./StandardModal.vue?vue&type=template&id=61646d48&scoped=true&"
import script from "./StandardModal.vue?vue&type=script&lang=js&"
export * from "./StandardModal.vue?vue&type=script&lang=js&"
import style0 from "./StandardModal.vue?vue&type=style&index=0&id=61646d48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61646d48",
  null
  
)

export default component.exports